var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "help_center_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 56,
    height: 56,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M26.917,35.06A2.893,2.893,0,0,1,24,38a2.928,2.928,0,0,1-2.94-2.94,2.928,2.928,0,0,1,5.857,0ZM23.977,10a8.312,8.312,0,0,0-8,5.81L19.8,17.42A4.462,4.462,0,0,1,24,13.967c3.78,0,4.527,3.547,3.2,5.437-1.26,1.8-3.43,3.01-4.573,5.04a8.891,8.891,0,0,0-.723,4.62h4.247c0-2.17.163-2.613.513-3.29.91-1.68,2.59-2.473,4.363-5.063a7.043,7.043,0,0,0-.047-7.187A7.837,7.837,0,0,0,23.977,10ZM40.333,7.667H7.667V40.333H40.333V7.667m0-4.667A4.68,4.68,0,0,1,45,7.667V40.333A4.68,4.68,0,0,1,40.333,45H7.667A4.68,4.68,0,0,1,3,40.333V7.667A4.68,4.68,0,0,1,7.667,3Z",
    transform: "translate(4 4)",
    fill: "#2f68fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBox);
export default __webpack_public_path__ + "static/media/question_box.4beff2d85d08539b5032ae946871f131.svg";
export { ForwardRef as ReactComponent };